function collectionMasonryImage(){
  const msnryImages = document.querySelectorAll('.product-list .product-block');
  // const msnryImages = Shopify.collectionMasonryImages
    $(document).ready(function(){
      collectionMasonry();
    })
  
  function collectionMasonry() {
    if (window.matchMedia("(min-width: 769px)").matches) {
      const msnry = new Masonry( '.product-list', { itemSelector: '.product-block' });
      
      const loadCollectionImages = new Promise(function(resolve, reject) {
        Shopify.collectionMasonryImages.forEach(({ index, src, thumb, title, layout }) => {
          if (msnryImages[index-1]) {
            msnryImages[index-1].insertAdjacentHTML("beforebegin", `
  			<div class="product-block layout__${layout} one-half amber">
  				<div class="block-inner" data-index="${index}" title="image">
  					<img class="rimage__image lazyload--manual fade-in cover" style="width: 100%" />
  				</div>
  			</div>`);
          
            const newTile = document.querySelector(`[data-index="${index}"]`);
            const newImage = newTile.querySelector(`img`);
          
            newTile.classList.add('loading');
         
            newImage.src = src;
            newImage.onload = function () {
            newTile.classList.add('loaded');
            newTile.classList.remove('loading');
            };
          };
          
        });
        resolve('Collection images loaded.');
      });
      
      loadCollectionImages.then(result => {
  		msnry.reloadItems();
        	msnry.layout();
      });
    }

    if (window.matchMedia("(max-width: 798px)").matches) {
      const msnry = new Masonry( '.product-list', { itemSelector: '.product-block' });
      
      const loadCollectionImages = new Promise(function(resolve, reject) {
        Shopify.collectionMasonryImages.forEach(({ index, src, mb_src, mb_thumb, thumb, title, mb_title, layout }) => {
          if (mb_title != '' ){
            if (msnryImages[index-1]) {
              msnryImages[index-1].insertAdjacentHTML("beforebegin", `
    			<div class="product-block layout__${layout} one-half amber">
    				<div class="block-inner" style="background-image: url('${mb_thumb}');" data-index="${index}" title="image">
    					<img style="width: 100%" />
    				</div>
    			</div>`);
            
              const newTile = document.querySelector(`[data-index="${index}"]`);
              const newImage = newTile.querySelector(`img`);
            
              newTile.classList.add('loading');
           
              newImage.src = mb_src;
              newImage.onload = function () {
              newTile.classList.add('loaded');
              newTile.classList.remove('loading');
              };
            };
          }else{
              if (msnryImages[index-1]) {
              msnryImages[index-1].insertAdjacentHTML("beforebegin", `
    			<div class="product-block layout__${layout} one-half amber">
    				<div class="block-inner" data-index="${index}" title="image">
    					<img class="rimage__image lazyload--manual fade-in cover" style="width: 100%" />
    				</div>
    			</div>`);
            
              const newTile = document.querySelector(`[data-index="${index}"]`);
              const newImage = newTile.querySelector(`img`);
            
              newTile.classList.add('loading');
           
              newImage.src = src;
              newImage.onload = function () {
              newTile.classList.add('loaded');
              newTile.classList.remove('loading');
              };
            };
          }
          
        });
        resolve('Collection images loaded.');
      });
      
      loadCollectionImages.then(result => {
  		msnry.reloadItems();
        	msnry.layout();
      });
    }
  
  $('.variant-input').click(function() {
    $(this).parent().find('.variant-input').removeClass('active')
    $(this).addClass('active') 
  });
  
  }
  
  // $('h4:contains("Filter by")').remove();
}
$(document).ready(function(){
  collectionMasonryImage();
});